import React from 'react';
import LandingTabs from './LandingTabs';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo7 from "../images/logo7.png"
import CustomizedMenus from "./menulist"
import Loginbotton from "./loginbotton"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 0,
    position: 'relative',
  },
  appBar: {
    background: 'rgba(255, 255, 255, 0.95)',
    boxShadow: 'none',
    borderBottom: '1px solid rgba(0, 45, 85, 0.12)',
    backdropFilter: 'blur(12px)',
  },
  shell: {
    width: 'min(1240px, calc(100% - 32px))',
    margin: '0 auto',
    padding: '14px 0',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 16px)',
      padding: '10px 0',
    },
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 12px)',
      padding: '8px 0',
    },
  },
  toolbar: {
    minHeight: 'unset',
    padding: '0 !important',
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr) auto',
    alignItems: 'center',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(84px, auto) minmax(0, 1fr) auto',
      gap: 8,
      alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'minmax(72px, auto) minmax(0, 1fr) auto',
      gap: 6,
    },
  },
  brandWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
    height: 56,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      height: 42,
      gap: 8,
    },
  },
  logo: {
    width: 'auto',
    height: '100%',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      maxHeight: 38,
    },
    [theme.breakpoints.down('xs')]: {
      maxHeight: 34,
    },
  },
  tabsWrap: {
    minWidth: 0,
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'center',
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 6,
    '& > *': {
      flexShrink: 0,
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-end',
      width: 'auto',
      gap: 4,
    },
  },
}));

export default function Header({ tabValue, tabs, onTabChange, onOpenClinicSignup, visible = true }) {
  const classes = useStyles();

  return (
    <div
      className={classes.root}
      style={{
        transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: visible ? 'translateY(0)' : 'translateY(-120%)',
        zIndex: 1000,
        position: 'sticky',
        top: 0,
      }}
    >
      <AppBar className={classes.appBar} position="static">
        <div className={classes.shell}>
          <Toolbar className={classes.toolbar}>
            <div className={classes.brandWrap}>
              <img src={logo7} alt="Virtus Physio" className={classes.logo} />
            </div>
            <div className={classes.tabsWrap}>
              <LandingTabs tabs={tabs} value={tabValue} onChange={onTabChange} />
            </div>
            <div className={classes.actions}>
              <CustomizedMenus />
              <Loginbotton onOpenClinicSignup={onOpenClinicSignup} />
            </div>
          </Toolbar>
        </div>
      </AppBar>
    </div>
  );
}








//import { AppBar, Toolbar, Typography } from "@material-ui/core";
//import React from "react";
//
// Standard metode, men den virker ikke, Header() vil ikke render
//export default function Header() {
//  const Header = () => {
//    return (
//      <AppBar position="static" color="primary">
//        <Toolbar>
//          <Typography>
//              Virtus Physio
//          </Typography>
//        </Toolbar>
//      </AppBar>
//    );
//  };
//}
//
//export default function Header() {
//  const displayDesktop = () => {
//    return <Toolbar>{VirtusphysioLogo}</Toolbar>;
//  };
////Hvordan bruger jeg et billede som logo istedet for text
//  const VirtusphysioLogo = (
//    <Typography variant="h6" component="h1">
//      Virtus Physio
//    </Typography>
//  );
//
//  return (
//    <header>
//      <AppBar position="static" color="primary">{displayDesktop()}</AppBar>
//    </header>
//  );
//}